import { createContext, useContext } from 'react';

export interface TicketsContextProps {
  getTickets();
  severity: Record<string, any>[];
  status: Record<string, any>;
  provider: Record<string, any>;
  resourceTypeOptions: Record<string, any>[];
  resourceType: Record<string, any>;
  assignee: Record<string, any>;
  assigneeOptions: Record<string, any>[];
  isOverDueDate: boolean;
  sortOrder: string;
  sortField: string;
  updateValue(field, value);
}

export const TicketsContext = createContext<TicketsContextProps>({
  getTickets: () => {},
  severity: [],
  status: {},
  provider: {},
  resourceTypeOptions: [],
  resourceType: {},
  assignee: {},
  assigneeOptions: [],
  isOverDueDate: false,
  sortOrder: '',
  sortField: '',
  updateValue: () => {},
});

export const TicketsContextProvider = TicketsContext.Provider;

export const useTicketsContext = () => useContext(TicketsContext);
